import { Image } from "@src/components/Image";
import React, { useEffect, useState, useRef } from "react";

import { getAwsAssets } from "@src/utils";

function BundleReceiptModal({
  customClass,
  customProps,
  children,
  handleClose = () => {},
  blockBackdrop,
}) {
  const [returnContent, setReturnContent] = useState(true);
  const timeoutRef = useRef(null);

  useEffect(() => {
    if (returnContent) {
    } else {
      timeoutRef.current = setTimeout(() => {
        if (typeof handleClose === "function") handleClose();
      }, 300);
    }
    return () => clearTimeout(timeoutRef?.current);
  }, [returnContent]);

  return (
    <div
      className={
        returnContent
          ? "ModalWrapper blockSlide ModalWrapper__Show"
          : "ModalWrapper blockSlide ModalWrapper__Hide"
      }
    >
      <div
        onClick={() => {
          if (!blockBackdrop) {
            setReturnContent(false);
          }
        }}
        className={
          returnContent ? "Backdrop Backdrop__Show" : "Backdrop Backdrop__Hide"
        }
      />
      <div
        className={
          returnContent
            ? `Modal Modal__Show ${customClass ? customClass : ""}`
            : `Modal Modal__Hide ${customClass ? customClass : ""}`
        }
        {...customProps}
      >
        <div>{children}</div>
      </div>
    </div>
  );
}

export default BundleReceiptModal;
